import { Component, OnInit, Input, forwardRef } from '@angular/core';
import { FormControl } from '@angular/forms';

import { NG_VALUE_ACCESSOR, NG_VALIDATORS, ControlValueAccessor } from '@angular/forms';

import { RootService } from '../../service/root.service';

export function validatePattren(c,pattern) {
    if(!c.dirty){
        return null;
    }
    let REGEXP = pattern;

    return (REGEXP.test(c.value)) ? null : {validatePattren: true};
}

@Component({

    selector: 'aFormRegex,[aFormRegex]',
    templateUrl: './aFormRegex.component.html',
    styleUrls: ['./aFormRegex.component.scss'],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: AFormRegexComponent, multi: true },
        { provide: NG_VALIDATORS, useExisting: AFormRegexComponent, multi: true },
    ]
})
export class AFormRegexComponent implements OnInit, ControlValueAccessor {
    @Input() id;
    @Input() label;
    @Input() placeholder;
    @Input() required;
    @Input() cClass;
    @Input() disabled;
    @Input() icon;
    @Input() pattern;
    @Input() errorLang;
    value;
    model;
    formControl;
    _onChange = (value: any) => { };

    registerOnChange(fn) {
        this._onChange = fn;
    }

    registerOnTouched() { }
    writeValue(value: any) {
        this.value = value;
    }
    
    validate(c: FormControl) {
        this.formControl = c;
        var pa = new RegExp('^'+this.pattern+'$', "i");
        return validatePattren(c,pa);
    }
    constructor(public rootService:RootService) {

    }

    ngOnInit() { }
}


// WEBPACK FOOTER //
// ./src/app/component/aFormRegex/aFormRegex.component.ts